// extracted by mini-css-extract-plugin
export default {"carousel-container":"ji8ylb5mdAspTh40ksrq","carousel-item":"TtymYuLEoJ1LK7cZqsSO"};